import { IFeedback } from '../models/feedback';
import { IApiResponse } from '../models/api-response';
import axios from 'axios';

const url = '/api/feedback';

export const sendFeedback = (feedBack: IFeedback): Promise<IApiResponse> => {
    return axios.post(`${url}/send`, feedBack);
};
